import React from 'react';
// styles
import styled from 'styled-components';

const EmptyCircleIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Empty circle"
    className={className}
    role="img"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="9.5" fill="white" stroke="#CCD6E0" />
  </svg>
);

export default styled(EmptyCircleIcon)``;
